/*
 * Allociné image-CDN URL builder. The runtime GraphQL APIs are now served by Athena
 * (see AthenaApi.ts); the only thing retained from the old Allociné client is this
 * helper, because Athena poster URLs are hosted on the same Allociné CDN and use the
 * same crop/resize path filters.
 */

type FormatOptions = {
  crop?: {
    width: number; // integer, width in px of the cropped image
    height: number; // integer, height in px of the cropped image
  };
  resize?: {
    width: number; // integer, width in px of the cropped image
    height: number; // integer, height in px of the cropped image
  };
  border?: {
    width: number; // integer, width in px of the border
    color: string; // string, color code of the border
  };
};
export const getPictureUrl = (source: string, format: FormatOptions = {}) => {
  const filters = [];
  if (format.crop) {
    const cropParams = ['c'];
    cropParams.push(format.crop.width.toString());
    cropParams.push(format.crop.height.toString());
    filters.push(cropParams.join('_'));
  } else if (format.resize) {
    const resizeParams = ['r'];
    resizeParams.push(format.resize.width.toString());
    resizeParams.push(format.resize.height.toString());
    filters.push(resizeParams.join('_'));
  }
  if (format.border) {
    const borderParams = ['b', format.border.width, format.border.color];
    filters.push(borderParams.join('_'));
  }
  /*
    Overlay filter, format filter & quality filter are intentionally not implemented
   */

  const filtersUrl = filters.length ? `/${filters.join('/')}` : '';
  const path = `${source}${filtersUrl}`;

  // Athena poster URLs are absolute (`https://all.web.img.acsta.net/...`) whereas the
  // old Allociné paths were protocol-relative (`//...`). Only prepend the page protocol
  // for the latter — otherwise we'd produce `https:https://...`.
  if (/^https?:\/\//.test(source)) {
    return path;
  }

  return `${document.location.protocol}${path}`;
};

export default getPictureUrl;
